/**
 * @author：
 * @update：
 * @description：
 **/
import {agreementsGet,agreementsSeach} from '@/api/agreement'
import download from "downloadjs";
import {fileEcho} from "@/api/url";
import CusPagination from "@/components/cusPagination";

export default {
    components: {
        CusPagination,
    },
    data() {
        return {
            searchForm: {
                orderNo: '',
                uniqueId:'',
                buyerName:'',
                storeName:'',
                createdDate:''
            },
            tableData: [],
            selectData:[],
            tableDataLoc:fileEcho,
            currentPage: 1,
            pageSize: 10,
            total:0,
        };
    },
    // 自定义方法
    methods: {
        //搜索
        seachBtn() {
            this.getList();
        },
        //重置
        resetBtn() {
            this.searchForm.orderNo = '';
            this.searchForm.uniqueId = '';
            this.searchForm.storeName = '';
            this.searchForm.buyerName = '';
            this.searchForm.createdDate = '';
            this.cutCreatedDate = '';
            this.getList();
        },
        //获取数据
        getList() {
            if (this.searchForm.createdDate.length > 0) {
                this.cutCreatedDate = (this.searchForm.createdDate[0]+' 00:00:00' + ',' + this.searchForm.createdDate[1]+' 00:00:00')
            }
            this.$ajax.get(agreementsGet,{
                orderNo: this.searchForm.orderNo,
                uniqueId: this.searchForm.uniqueId,
                storeName:this.searchForm.storeName,
                buyerName: this.searchForm.buyerName,
                createdDate: this.cutCreatedDate,
                pageSize: this.pageSize,
                pageNumber: this.currentPage
            }).then((res) => {
                if (res.status === 200) {// 成功了
                    this.tableData = res.data.rows;
                    this.total = res.data.total;
                }
            }, (err) => {
                console.log(err);
            })
        },
        //详情
        detailsClick(row) {
            this.$ajax.get(agreementsSeach(row.orderItem.id)).then((res) => {
                if (res.status === 200) {// 成功了
                    // window.location.href = this.tableDataLoc + res.data.content.location;//在本页面打开
                    window.open(this.tableDataLoc + res.data.content.location, "_blank", '');//在新页面打开
                }
            }, (err) => {
                console.log(err);
            })
        },
        //下载
        downloadClick(row) {
            this.$ajax.get(agreementsSeach(row.orderItem.id)).then((res) => {
                if (res.status === 200) {// 成功了
                    // window.location.href = this.tableDataLoc + res.data.content.location;//在本页面打开
                    // window.open(this.tableDataLoc + res.data.content.location, "_blank", '');//在新页面打开
                    let row = res.data.content
                    let fileName = row.filename.lastIndexOf(".");//取到文件名开始到最后一个点的长度
                    let fileNameLength = row.filename.length;//取到文件名长度
                    let fileFormat = row.filename.substring(fileName + 1, fileNameLength);//截取文件的后缀名。
                    console.log(fileFormat,111111);
                    if (fileFormat == 'xls' || fileFormat == 'xlsx') {
                        let link = document.createElement("a");
                        link.style.display = "none";
                        link.href = this.tableDataLoc + row.location;
                        link.setAttribute("download", row.filename);
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link); // 下载完成移除元素
                    } else {
                        download(this.tableDataLoc + row.location);
                    }
                }
            }, (err) => {
                console.log(err);
            })
        },
        //列表多选
        selectionChange(val) {
            // console.log(val);
            for (let i = 0; i < val.length; i++){
                this.selectData = val
            }
        },
        //批量下载
        batchBtn(){
            for (let i = 0; i < this.selectData.length; i++){
                download(this.tableDataLoc + this.selectData[i].content.location);
            }
            console.log(this.selectData);
        }
    },
    // 数据观察监听
    watch: {
        currentPage(newData,oldData){
            this.getList()
        },
        pageSize(newData,oldData){
            this.getList()
        },
    },
    // 计算数据
    computed: {},
    // 组件数据创建之前
    beforeCreate() {

    },
    // 组件数据创建完成
    created() {
        this.getList();
    },
    // 组件挂载完成之前
    beforeMount() {

    },
    // 组件挂载完成
    mounted() {

    },
    // 组件即将销毁
    beforeDestroy() {

    },
    // 组件销毁
    destroyed() {

    },
    // 组件激活
    activated() {

    },
    // 组件冻结
    deactivated() {

    }
};
